import { isIntegratedDisease } from 'modules/questionnaire/helpers';
import { formatOptionsFromServerData } from './formatOptionsFromServerData';

export async function getOptionsFromServer(disease, question, optionsFromServer) {
  if (isIntegratedDisease(disease)) {
    const options = question.options.map((option) => ({
      code: option.value,
      name: option.label,
      topSelectedForConditions: option.topSelectedForConditions,
    }));
    return formatOptionsFromServerData(options, question.id);
  }

  return optionsFromServer[question.id] ?? {};
}
